var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.7 9.3H50v12.1c0 5-3 8-8.6 9.4-4-1-8.6-3-8.6-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a2bd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M33.1 9.6h16.4v11.7q0 7-8.2 9c-3.8-1-8.2-3-8.2-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a53d08",
    d: "M49.4 22.7c-.6 4.5-4 6.4-8 7.5-3.6-1-7.4-2.5-8.2-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.7 11.8v-1.5h1.1v1.5H45v1.1h-3.2v13.5h-1.1V13h-3.2v-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a08",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38 23.2 3 3c1-1 .3-5.2-1-6q-.3.9-.7 1.3c-.7.4-2.2 1-1.7 1.3q.2-.4.6 0c.1.6-.7.6-.7.6s-.5 0-.6-.6.8-1 .9-1 1.2-.3 1.4-1.3.4-.9.5-.9c1.5.2 2.4 2.8 2.5 4.6 0 1.9-.8 3.1-1 3.2l-3.4-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a08",
    d: "M40.2 20.4V26Zm-.3.1v5Zm-.4.7v4Zm-.3.3v3.3Zm-.3.2v2.7Zm-.3.2V24Zm-.3.2v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.2 20.4V26m-.3-5.4v5m-.4-4.3v4m-.3-3.7v3.3m-.3-3.1v2.7m-.3-2.5v2m-.3-2v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffdf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m38 23.6 3 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffdf00",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "M41.2 21.4s1.4 3 0 5.4M37.8 23l.2-.1m-.4-.6s-.6.5-.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008021",
    d: "M41.8 14.6q.3-.3.5-.2h.4q.4-.2 1-.1l.4.2q.3.2.3 1.1v1.5q-.2 1.2-.6 1.2l.7 1.7q.4.8.3 2.4c-.1 1-.4 3.4.4 4.9l-.7-.3q-.3-.4-.7-.1c-.7.5-1.4 1.2-2.4.5q-.4-.1-.1-.8c.4-1.1.6-2.8.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe1cf",
    d: "M42.5 13.9v1.3l.8-.5.4-.4q-.4-.2-.3-.6c0-.4.5-.7 0-1.2a1 1 0 0 0-1 0l-.1.3-.2.2v.8zm-1.9 2-1-.1q-.2 0-.2-.2V15l.3-1.2q.3-.4.3-1l.2-.4.1-.2h.2v.1l.2-.2h.4v.4l-.3.2-.3.3-.1.2c0 1.5-.2 1.3-.2 1.7v.2l.4-.1zm.1 3.1 1.2-.4.9-.3.5-.3.3-.3q.5-.8.5-1.8.1-.6-.4-.5-.5.5-.7 1.1l-.3.8-.2.1q-.7.2-1.2.6l-1.2.7-.4.4-.2.3v.8l.1-.2q0 .2.1 0h.4v-.3l.3-.4zm3.1 7.9.1.3v.1l-.2.7-.2.3.1.2h.2l.2-.1h.1l.2-.1.1-.2v-.2l.1-.3.1-.3V27l-.5-.2zm-2.7.8h.6l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#870f00",
    d: "M42.5 12.4q0-.4.4-.3h.4q.4 0 .4.3l.2.3v.2q.4 0 .3.3.2.2.1.5t-.4 0h-.6l-.2-.2v-.9q-.3 0-.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 13.9.4-.1m-.8-.4h.2m.3-1c-.1 0 .2-.3.5 0h.3m-.4.2.5.1c0 .2.2 0 .3.3q0 .4.4.2m-.6.5V13m-.5.2.2.1m.6.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.2 12.8.2.2.3.2m0-.8-.4-.2m-.7 3q-.3.3-.2 1c0 .4.2 1-.2 1.3m1.6.8-.7.1h-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 18.3q-.2 0-.2.5v1.4m-.1-1.7q-.2 0-.2.3m-.5 0q0-.4.3-.3m1.1.4q0-.7-.2-.6.3-.2.4.8 0 .6.3 1.2c.3 1.1.2 2.8.3 3.5m-1-4.8a6 6 0 0 1 0 4.1l.8 2.4m-2-4c0-.2-.2-.3 0-1.1q.2-.6 0-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4 20.2c0 .4.3 1 0 1.6m-.4 0V23q0 .4.4.7.8 1.6.9 3 0 .4-.2.7m-1 .3.1-.2q.3-1 .2-2m.2.9-.1 1m.5-1.7V27m-.3 0v.7m.8-3c.3.6.6 2 .9 2.3m-.6-.2-.1-.5M39.9 20l.1-.4m-.2.4v-.5m-.2.5v-.5m1.3-7.4-.4.3m.5-.2-.4.3m.4-.2-.3.3m-.2-.3-.2.1m3.5 16v-.2m.2.2v-.2m.1.1v-.2m.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m42.4 12.7.1.2h-.1zm0 0h.3v.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.9d7f1f319e4666c2efcba046285bd872.svg";
export { ForwardRef as ReactComponent };